import { Link } from "react-router-dom";
import { useSettings } from "@/context/SettingsContext";
import { mediaUrl } from "@/lib/api";

const imgSrc = (img) =>
  img && (img.startsWith("/api/") || img.startsWith("http")) ? mediaUrl(img) : img;

export default function Logo({ dark = false, className = "", imgClassName = "h-9 md:h-11", variant = "header" }) {
  const { settings } = useSettings();
  const brand = settings?.brand || {};
  const color = dark ? "text-linen" : "text-ink";
  const logo = brand[`${variant}_logo`] || brand.logo;
  return (
    <Link to="/" data-testid="brand-logo" className={`inline-flex flex-col items-center leading-none ${color} ${className}`}>
      {logo ? (
        <img src={imgSrc(logo)} alt={brand.name || "Sew Voyage"} className={`${imgClassName} w-auto object-contain`} />
      ) : brand.name ? (
        <span className="font-heading italic font-medium text-3xl md:text-4xl tracking-tight text-center">{brand.name}</span>
      ) : (
        <>
          <span className="font-heading italic font-medium text-3xl md:text-4xl tracking-tight">Sew</span>
          <span className="font-body uppercase tracking-luxe text-[0.6rem] md:text-xs -mt-1">Voyag&eacute;</span>
        </>
      )}
    </Link>
  );
}
